/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-redundant-roles */
import { useLoadSiteFooter } from 'hooks/useLoadSiteFooter';
import { observer } from 'mobx-react-lite';
import { Footer } from 'petdna-lib-uicomponents/components';
import React, {
  useCallback,
  useEffect, useMemo, useState,
} from 'react';

import FooterLoadingState from './FooterLoadingState';

interface MyWindow extends Window {
  _sp_?: {
    ccpa?: {
      loadPrivacyManagerModal: (id: string) => void;
    };
    gdpr?: {
      loadPrivacyManagerModal: (id: string) => void;
    };
  };
}

const ccpaNoticeElementId = 'ccpaNoticeAtCollection';

const SiteFooter: React.FC = observer(() => {
  const { footerData } = useLoadSiteFooter();
  const myWindow = window as MyWindow;
  const [showCCPAButtton, setShowCCPAButtton] = useState(false);
  const [showGDPRButton, setShowGDPRButton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!footerData) return;

      const localStorageItem = localStorage.getItem('_sp_user_consent_31379');
      if (localStorageItem) {
        try {
          const parsedData = JSON.parse(localStorageItem);

          if (parsedData.ccpa.applies) {
            setShowCCPAButtton(true);
          } else if (parsedData.gdpr.applies) {
            setShowGDPRButton(true);
            const el = document.getElementById(ccpaNoticeElementId);
            if (el) {
              el.style.display = 'none';
            }
          }
        } catch (e) {
          console.error('Error parsing LocalStorage', e);
        }
      } else {
        console.warn('Ítem not Found');
      }
    }, 1250);

    return () => {
      clearTimeout(timer);
    };
  }, [footerData]);

  const handleGDPR = useCallback(() => {
    myWindow._sp_!.gdpr!.loadPrivacyManagerModal('812894');
  }, [myWindow]);

  const handleCCPA = useCallback(() => {
    myWindow._sp_!.ccpa!.loadPrivacyManagerModal('812895');
  }, [myWindow]);

  const privacySettings = useMemo(() => {
    if (showCCPAButtton) {
      return {
        onPrivacySettingsClick: handleCCPA,
        privacySettingsLabel: 'Do Not Sell or Share My Personal Information',
      };
    }

    if (showGDPRButton) {
      return {
        onPrivacySettingsClick: handleGDPR,
        privacySettingsLabel: 'GDPR Privacy Settings',
      };
    }

    return null;
  }, [
    showCCPAButtton,
    showGDPRButton,
    handleCCPA,
    handleGDPR,
  ]);

  return (
    footerData
      ? <Footer {...footerData} privacySettings={privacySettings} />
      : <FooterLoadingState />);
});

export default SiteFooter;
